import { pakistanCellNumberPattern, pakistanLandlineNumberPattern, pakistanCNICPattern } from "@schemas/validationPatterns";
import z from "zod";

const normalizeLandline = (value: string): string => value.replace(/[\s\-()]/g, "");

export const createProfileSchema = () => {
	return z.object({
		// Business Details
		businessName: z.string().min(1, "Business name is required"),
		officeLandlineNumber: z
			.string()
			.min(1, "Office landline number is required")
			.refine(value => pakistanLandlineNumberPattern.test(normalizeLandline(value)), "Invalid landline number format"),
		websiteURL: z.string().url("Invalid URL format").optional().or(z.literal("")),
		principalLineOfBusiness: z.string().min(1, "Principal line of business is required"),
		registeredOfficeAddress: z.string().min(1, "Registered office address is required"),
		sector: z.string().min(1, "Sector is required"),
		
		// Contact Person Details
		personFullName: z.string().min(1, "Full name is required"),
		personCnic: z
			.string()
			.min(1, "CNIC is required")
			.regex(pakistanCNICPattern, "Invalid CNIC format (e.g., 3230191645897)"),
		personLandline: z
			.string()
			.optional()
			.or(z.literal(""))
			.refine(value => !value || pakistanLandlineNumberPattern.test(normalizeLandline(value)), "Invalid landline number format"),
		personMobile: z
			.string()
			.min(1, "Mobile number is required")
			.regex(pakistanCellNumberPattern, "Invalid mobile number format"),
		personEmail: z
			.string()
			.min(1, "Personal email is required")
			.email("Invalid email format"),
		businessEmailAddress: z
			.string()
			.min(1, "Business email is required")
			.email("Invalid email format"),
		personAddress: z.string().optional().or(z.literal("")),
		
		// KYC Details
		employerType: z.string().min(1, "Employer type is required"),
		ntn: z.string().min(1, "Tax number is required"),
	});
};
